import {
  createGeneratedOpsApi,
  type GeneratedOpsApi,
  type OpsApiTransport,
} from "src/generated/client"

// Re-export the error helpers so call sites import everything API-related from one place.
export { ApiError, apiErrorMessage } from "src/generated/client"
export type { GeneratedOpsApi, OpsApiTransport } from "src/generated/client"

/** localStorage key the auth token is stored under; the fetch transport reads it from there. */
export const AUTH_TOKEN_KEY = "bx-ops-auth-token"

let client: GeneratedOpsApi | null = null

// 401 handler, registered by App.vue. Kept as a settable callback rather than importing the auth
// store directly so this module stays dependency-free of the stores — the auth store imports
// `useOpsApi` from here, so a direct import back would create a circular dependency.
let unauthorizedHandler: () => void = () => {}

/** Registers the callback invoked when an API call returns 401 (e.g. to lock the session out). */
export function setUnauthorizedHandler(handler: () => void): void {
  unauthorizedHandler = handler
}

/** Invoked by the fetch transport on a 401 response. */
export function notifyUnauthorized(): void {
  unauthorizedHandler()
}

/** Initializes the API client with the given transport (real `fetch` or mock). Called once at boot. */
export function initOpsApi(transport: OpsApiTransport): void {
  client = createGeneratedOpsApi(transport)
}

/** The typed OpsApi client. Throws if accessed before the `api` boot file initialized it. */
export function useOpsApi(): GeneratedOpsApi {
  if (!client) {
    throw new Error(
      "OpsApi client not initialized — is the 'api' boot file registered in quasar.config.ts?",
    )
  }
  return client
}
